import { useFormContext } from 'react-hook-form';
import { StyledHeaderComponent } from '../styles';
import { IRenderTemplateRow } from '../types';
import { evaluateDependencyItem, shouldRenderEmptyComponent } from '../utils';

interface HeaderComponentProps {
  row: IRenderTemplateRow;
  pageName?: string;
}

export const HeaderComponent = ({ row, pageName }: HeaderComponentProps) => {
  const { dependsOn } = row;
  const { watch } = useFormContext();
  const dependentValue = dependsOn ? watch(`${pageName}.${dependsOn.name}`) : null;
  const hasValidOrDependency: boolean = dependsOn?.or
    ? dependsOn.or.some((item: any) => {
        const dependentValue = watch(`${pageName}.${item.name}`);
        return evaluateDependencyItem(dependentValue, item);
      })
    : null;
  const hasValidAndDependency: boolean = dependsOn?.and
    ? dependsOn.and.every((item: any) => {
        const dependentValue = watch(`${pageName}.${item.name}`);
        return evaluateDependencyItem(dependentValue, item);
      })
    : null;

  if (shouldRenderEmptyComponent(dependsOn, dependentValue, hasValidOrDependency, hasValidAndDependency)) return <></>;

  return <StyledHeaderComponent>{row?.config?.content || ''}</StyledHeaderComponent>;
};
